import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
//import CardBody from "components/Card/CardBody.js";
import Button from "@mui/material/Button";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import { Tooltip } from "@material-ui/core";
import dayjs from "dayjs";
import PropTypes from "prop-types";
const BlueOnGreenTooltip = withStyles({
  tooltip: { backgroundColor: "#c2c800" },
})(Tooltip);
const Tracuuhoatdongtable = React.memo(function Tracuuhoatdongtable(props) {
  const classes = useStyles();
  const { doanhnghiep, hoatdong, vipham } = props;
  const [opentracuu, setOpentracuu] = React.useState(false);
  const [openchitiet, setOpenchitiet] = React.useState(false);
  const [chitiet, setChitiet] = React.useState("");
  const handleClosetracuu = () => {
    setOpentracuu(false);
  };
  const handleClosechitiet = () => {
    setOpenchitiet(false);
  };
  const newline = (text) => {
    if (text) {
      let newText = text.split("\\n").map((str, i) => <p key={i}>{str}</p>);
      return newText;
    }
  };
  const chuyendoingay = (ngay) => {
    if (ngay) return dayjs(ngay).format("DD/MM/YYYY");
  };
  const getlaixe = (text) => {
    if (text["laixe"]) {
      let newText = text["laixe"]
        .split("\\n")
        .map((str, i) => <span key={i}>{str + "; "}</span>);
      return newText;
    }
  };
  const shownoidung = (item) => {
    setOpenchitiet(true);
    setChitiet(newline(item.thongtin));
  };
  const dulieuhoatdong = () => {
    let newText = hoatdong.map((item, i) => {
      return (
        <div key={i} style={{ display: "flex" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "75%" }}>
              <BlueOnGreenTooltip
                title={<a className={classes.tooltip}>Tra cứu thông tin</a>}
                placement="top-start"
                cusor="pointer"
              >
                <>
                  <span style={{ fontWeight: "bold" }}>
                    {"Ngày: " + chuyendoingay(item["ngay"])}
                  </span>
                  <p key={i}>{getlaixe(item)}</p>
                </>
              </BlueOnGreenTooltip>
            </FormControl>
            <FormControl style={{ width: "12%" }}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => shownoidung(item)}
                style={{ height: "30px", marginTop: 10 }}
              >
                Chi tiết
              </Button>
            </FormControl>
            <FormControl style={{ width: "13%" }}>
              <Button
                color="success"
                variant="contained"
                onClick={() => setOpentracuu(true)}
                style={{ height: "30px", marginTop: 10, marginLeft: 10 }}
              >
                Tra cứu
              </Button>
            </FormControl>
          </GridItem>
        </div>
      );
    });
    return newText;
  };
  const getvipham = () => {
    let newText = vipham.map((item, i) => {
      return (
        <div key={i} style={{ display: "flex" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "75%" }}>
              <p key={i}>
                {"Ngày: " + item["ngayvipham"] + " - " + item["motavipham"]}
              </p>
            </FormControl>
          </GridItem>
        </div>
      );
    });
    return newText;
  };
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th_dn} style={{ width: "20%" }}>
            Thông tin
          </th>
          <th className={classes.tablebc_th_dn}>Nội dung</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Tên doanh nghiệp</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0] ? newline(doanhnghiep[0].thongtindonvi) : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Loại hình vận tải</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0] ? doanhnghiep[0].dmloaihinhvantai : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Số đăng ký</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0] ? doanhnghiep[0].sodangky : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Sức chứa</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0] ? doanhnghiep[0].succhua : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Tải trọng</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0] ? doanhnghiep[0].taitrong : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Thông tin phù hiệu</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0] ? doanhnghiep[0].thongtinphuhieu : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Hoạt động</td>
          <td className={classes.tablebc_td_dn}>
            {hoatdong[0] ? dulieuhoatdong() : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn_bold}>Vi phạm</td>
          <td className={classes.tablebc_td_dn}>
            {vipham[0] ? getvipham() : null}
          </td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "497px" }}>
      <a
        style={{
          display: "block",
          textAlign: "center",
          color: "blue",
          fontWeight: "bold",
          fontSize: 18,
          marginTop: 10,
        }}
      >
        THÔNG TIN VỀ HOẠT ĐỘNG CỦA PHƯƠNG TIỆN
      </a>
      <table className={classes.tablebc} style={{ marginTop: 8 }}>
        {tHead}
        {tBody}
      </table>
      <Modal
        open={opentracuu}
        onClose={handleClosetracuu}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={4}>
              <Card>
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl
                    style={{ width: "100%", marginTop: 10, marginLeft: 20 }}
                  >
                    <a
                      href="https://gplx.csgt.bocongan.gov.vn/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue", fontWeight: "bold" }}
                    >
                      Tra cứu Website Thông tin giấy phép lái xe
                    </a>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl
                    style={{ width: "100%", marginTop: 10, marginLeft: 20 }}
                  >
                    <a
                      href="https://gsht.drvn.gov.vn/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue", fontWeight: "bold" }}
                    >
                      Tra cứu Giám sát hành trình
                    </a>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl
                    style={{ width: "100%", marginTop: 10, marginLeft: 20 }}
                  >
                    <a
                      href="https://nghiepvu.gplx.gov.vn/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue", fontWeight: "bold" }}
                    >
                      Tra cứu nghiệp vụ giấy phép lái xe
                    </a>
                  </FormControl>
                </GridItem>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      <Modal
        open={openchitiet}
        onClose={handleClosechitiet}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl
                    style={{
                      width: "100%",
                      marginTop: 10,
                      marginLeft: 20,
                      fontWeight: "bold",
                    }}
                  >
                    {chitiet}
                  </FormControl>
                </GridItem>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
    </div>
  );
});

Tracuuhoatdongtable.propTypes = {
  doanhnghiep: PropTypes.array,
  hoatdong: PropTypes.array,
  vipham: PropTypes.array,
};
export default Tracuuhoatdongtable;
